/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_ADVERTISER (state, {data}) {
        state.products.unshift(data.result[0])
    },
    EDIT_ADVERTISER (state, {data, income}) {
        for (const index in state.products) {
            if (state.products[index].id === data.result[0].id) {
                Object.assign(state.products[index], data.result[0])
            }
        }
    },
    ADD_INTEGRATION (state, {data, income}) {
        for (const index in state.products) {
            if (state.products[index].id === income.data.ids.advId) {
                Object.assign(state.products[index], data.result[0])
            }
        }
    },
    EDIT_INTEGRATION (state, {data, income}) {
        for (const index in state.products) {
            if (state.products[index].id === income.data.ids.advId) {
                Object.assign(state.products[index], data.result[0])
            }
        }
        // Object.assign(state.products[income.data.ids.advArrId], data.result[0])
        // state.products[response.ids.advArrId].advertiser_integrations[response.ids.intArrId].unshift(response.item[0])
    },
    SET_PRODUCTS (state, {data}) {
        state.products = data.result.advertisers
    },
    CHANGE_ADVERTISER_STATUS (state, {income}) {
        for (const index in state.products) {
            if (state.products[index].id === income.data.id) {
                state.products[index].is_active = !state.products[index].is_active
                confirm
            }
        }
    },
    CHANGE_INTEGRATION_STATUS (state, {income}) {
        for (const index in state.products) {
            if (state.products[index].id === income.data.id) {
                state.products[index].advertiser_integrations[income.intArrId].is_active = !state.products[index].advertiser_integrations[income.intArrId].is_active    
            }
        }
        // state.products[income.advid].advertiser_integrations[income.intArrId].is_active = !state.products[income.advid].advertiser_integrations[income.intArrId].is_active
    }
}
